module.exports = __webpack_public_path__ + "static/media/brush_4.9f615f82.png";